export const environment = {
  production: false,
  console: true,
  API_URL: 'https://apides.apiacpos.com/api_bridge/',
  API_URL_MS: 'https://apides.apiacpos.com/WEBAPICoreBridge/',
  numSerie: 'WEBAN$A$l06$A$GULAR$A$AM3[jC)',
  chClaveEmpresa: 'ARGONNE',
  chNombreProyecto: 'VENTAONLINE',
  chEntornoConexion: 'DESARROLLO',
  chOrigenConexion: 'INTERNET',
  chPasarelaEntorno: 'DESARROLLO',
  pasarelaRedsys: 'DESARROLLO',
  pasarelaPhoneSell: 'PHONE_M_DES',
  pasarelaEntornoPhoneSell: 'CONSULTA_DES',
  pasarelaPaypal: 'PAYPAL_DES',
  URL_PDF: 'http://argonne.pruebas.iacpos.com/argonne-api/tickets/',
  URLOK: 'https://tickets.argonne.iacposdes.com/thankyou',
  URLKO: 'https://tickets.argonne.iacposdes.com/thankko',
  URL: 'https://tickets.argonne.iacposdes.com/',
  siteKey: '6LfXS2IUAAAAADr2WUPQDzAnTEbSQzE1Jxh0Zi0a',
  timer: 20,
  siteKeyV3: '6LcC6uYpAAAAAKWKAGoaja5hIXbOSboGL7UssUnw',
  showCaptcha: true,
  recaptchaVersion: 2,
  LANGUAGE_DEFAULT: 'fr-FR'
};
